import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  SubmitButton,
  CancelPopupButton,
  SelectField,
} from "../../ui/FormElement";
import formSave from "./formSave";

import routes from "../../app/routes";
import axios from "axios";

export default function Form({
  initialFormValues,
  closeForm,
  updateCollection,
}) {
  let FormSchema = Yup.object().shape({
    enterprise: Yup.number().typeError("Please, choose Enterprise"),
    team: Yup.number().typeError("Please, choose team"),
  });

  let [loader, setLoader] = useState(false);

  const [enterprises, setEnterprises] = useState();
  const [enterprisesRawData, setEnterprisesRawData] = useState();
  const [teams, setTeams] = useState();

  const selectEnterprise = useRef(null);
  const selectTeam = useRef(null);

  const loadEnterprises = () => {
    axios.get(routes.api.enterprises.list).then((resp) => {
      setEnterprisesRawData(resp.data.data);

      let values = resp.data.data.map(function (item) {
        return {
          value: item.id,
          label: item.attributes.name,
        };
      });

      setEnterprises(values);

      if (initialFormValues.enterprise != null) {
        const selectedValue = values.find(
          (element) =>
            parseInt(element.value) == parseInt(initialFormValues.enterprise)
        );
        selectEnterprise.current.select.setValue(selectedValue);
      }
    });
  };

  const loadTeams = (value) => {
    const enterprise = enterprisesRawData.find(
      (element) => parseInt(element.id) == parseInt(value)
    );

    let values = enterprise.attributes.teams.map(function (item) {
      return {
        value: item.id,
        label: item.title,
      };
    });

    setTeams(values);

    if (initialFormValues.team != null) {
      const selectedValue = values.find(
        (element) => parseInt(element.value) == parseInt(initialFormValues.team)
      );
      selectTeam.current.select.setValue(selectedValue);
    }
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    formSave(values, initialFormValues, function () {
      closeForm();
      swal("Record updated.");
      updateCollection();
    });
  };

  useEffect(() => {
    loadEnterprises();
  }, []);

  return (
    <BaseForm
      enableReinitialize={true}
      validationSchema={FormSchema}
      initialValues={initialFormValues}
      onSubmit={onSubmit}
    >
      <SelectField
        ref={selectEnterprise}
        name="enterprise"
        label={
          <>
            <span>Enterprise</span>
            <abbr title="required">*</abbr>
          </>
        }
        placeholder={
          enterprises == undefined
            ? "Enterprise is loading ..."
            : "Choose Enterprise..."
        }
        options={enterprises}
        onCustomonChange={(option) => loadTeams(option.value)}
      />

      <SelectField
        ref={selectTeam}
        name="team"
        label={
          <>
            <span>Team</span>
            <abbr title="required">*</abbr>
          </>
        }
        placeholder="Choose Teams..."
        options={teams}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Create"}
          className="btn width-120 btn-primary submit-button mr5 ml5"
        />
      </div>
    </BaseForm>
  );
}
